const TURNSTILE_SCRIPT = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

/** Public Cloudflare site key. Safe in frontend code. Override with REACT_APP_TURNSTILE_SITE_KEY. */
export const PUBLIC_TURNSTILE_SITE_KEY = '0x4AAAAAAFOXZt5CpZlbV9Z4';

export function turnstileSiteKey() {
  const fromEnv = String(process.env.REACT_APP_TURNSTILE_SITE_KEY || '').trim();
  return fromEnv || PUBLIC_TURNSTILE_SITE_KEY;
}

function loadTurnstile() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('The anti-bot check is unavailable.'));
  }
  if (window.turnstile) return Promise.resolve(window.turnstile);

  return new Promise((resolve, reject) => {
    const fail = () => reject(new Error('The anti-bot check failed. Try again.'));
    const existing = document.querySelector('script[data-liwaza-turnstile="1"]');
    if (existing) {
      existing.addEventListener(
        'load',
        () => (window.turnstile ? resolve(window.turnstile) : fail()),
        { once: true }
      );
      existing.addEventListener('error', fail, { once: true });
      return;
    }
    const script = document.createElement('script');
    script.src = TURNSTILE_SCRIPT;
    script.async = true;
    script.defer = true;
    script.dataset.liwazaTurnstile = '1';
    script.onload = () => (window.turnstile ? resolve(window.turnstile) : fail());
    script.onerror = fail;
    document.head.appendChild(script);
  });
}

export async function getTurnstileToken() {
  const siteKey = turnstileSiteKey();
  if (!siteKey) return '';
  const turnstile = await loadTurnstile();
  const container = document.createElement('div');
  container.style.position = 'absolute';
  container.style.left = '-9999px';
  document.body.appendChild(container);

  return new Promise((resolve, reject) => {
    let widgetId = '';
    const cleanup = () => {
      try {
        if (widgetId) turnstile.remove(widgetId);
      } catch {
        /* ignore */
      }
      container.remove();
    };
    widgetId = turnstile.render(container, {
      sitekey: siteKey,
      size: 'invisible',
      callback: (token) => {
        cleanup();
        resolve(token);
      },
      'error-callback': () => {
        cleanup();
        reject(new Error('The anti-bot check failed. Try again.'));
      },
      'timeout-callback': () => {
        cleanup();
        reject(new Error('The anti-bot check failed. Try again.'));
      },
    });
    try {
      turnstile.execute(widgetId);
    } catch {
      /* render already executes invisible widgets */
    }
  });
}
